export class MemoryReport {
  constructor(
    public name: string,
    public value: any,
    public unit: string,
    public reports?: MemoryReport[],
  ) {}
}
